import {accountMovement} from "./en/accountMovement";
import {bankDeposit} from "./en/bankDeposit";
import {baseModalTitles} from "./en/baseModalTitles";
import {changePassword} from "./en/changePassword";
import {contact} from "./en/contact";
import {currency} from "./en/currency";
import {deleteAccount} from "./en/deleteAccount";
import {dropdownMenu} from "./en/dropdownMenu";
import {errorBoundary} from "./en/errorBoundary";
import {floatBtn} from "./en/floatBtn";
import {floatingMenu} from "./en/floatingMenu";
import {footer} from "./en/footer";
import {gameFeed} from "./en/gameFeed";
import {games} from "./en/games";
import {homeBtnMoneyHandler} from "./en/homeBtnMoneyHandler";
import {homeModalSessionInfo} from "./en/homeModalSessionInfo";
import {inviteFriend} from "./en/inviteFriend";
import {loginModal} from "./en/loginModal";
import {lottery} from "./en/lottery";
import {mobilePayment} from "./en/mobilePayment";
import {notificationDrawer} from "./en/notificationDrawer";
import {notifications} from "./en/notifications";
import {raffle} from "./en/raffle";
import {registrationForm} from "./en/registrationForm";
import {sideNavbar} from "./en/sideNavbar";
import {contactSupport} from "./en/support";
import {TOS} from "./en/TOS";
import {transactionTitles} from "./en/transactionTitles";
import {transferSteps} from "./en/transferSteps";
import {userProfile} from "./en/userProfile";
import {wallet} from "./en/wallet";
import {withdrawalSteps} from "./en/widthdrawalSteps";

const en = {
  ...contact,
  ...contactSupport,
  ...bankDeposit,
  ...currency,
  ...sideNavbar,
  ...dropdownMenu,
  ...registrationForm,
  ...userProfile,
  ...floatBtn,
  ...withdrawalSteps,
  ...homeBtnMoneyHandler,
  ...transferSteps,
  ...wallet,
  ...inviteFriend,
  ...changePassword,
  ...mobilePayment,
  ...accountMovement,
  ...transactionTitles,
  ...baseModalTitles,
  ...footer,
  ...notificationDrawer,
  ...notifications,
  ...deleteAccount,
  ...TOS,
  ...lottery,
  ...raffle,
  ...loginModal,
  ...errorBoundary,
  ...games,
  ...gameFeed,
  ...floatingMenu,
  ...homeModalSessionInfo,
  noDataAvailable: "No data available",
  loading: "Loading...",
  homeDisplaySportsTitle: "Sports Betting",
  homeDisplaySportsSubtitle: "Play in the best leagues in the world",
  homeDisplayContestChallengeTitle: "CONTEST - Challenge from beyond",
  homeDisplayTopGamesTitle: "10 Most Played!",
  homeDisplayAllBtn: "View All",
  homeDisplayLoginBtn: "Login",
  homeDisplayRegisterBtn: "Register",
  homeDisplayLiveGames: "Live Games",
  homeDisplayFootball: "Football",
  homeDisplayTennis: "Tennis",
  homeDisplayBasketball: "Basketball",
  homeDisplayVolleyball: "Volleyball",
  homeDisplayEventRules: "Event Rules",
  homeDisplayModalTitle: "Promotion",
  homeDisplayModalClose: "Close",
  homeModalSessionInfoAtTime: "at",
  referralMessage: "Join RYG and enjoy exclusive benefits! Sign up using my referral link ",
  referralMessageSlots: "Sign up here and receive 10 free spins on slots! ",
  referralMessageSports: "Create your account and get an exclusive bonus to bet on your favorite sport! ",
  referralMessageBingo: "Create your account and receive free bingo cards! ",
  referralMessageCasino: "Create your account and receive free chips for the live casino! ",
  selectMessageType: "Select message type",
  messageTypeGeneral: "General",
  messageTypeSlots: "Slots",
  messageTypeSports: "Sports",
  messageTypeBingo: "Bingo",
  messageTypeCasino: "Casino",
  messagePreview: "Message Preview",
  copy: "Copy",
  share: "Share",
  scanQR: "Scan QR",
  scanQRText: "Scan this QR to referral friend",
  copyQR: "Copy QR",
  downloadQR: "Download QR",
  shareQR: "Share QR",
  qrCopied: "QR code copied to clipboard!",
  qrCopyFailed: "Failed to copy QR code. Please try downloading instead.",
  recentReferrals: "Recent Referrals",
  referralProgram: "Referral Program",
  youReferralStatus: "Your referral status",
  sharedYourLink: "You can share your referral link by copying and sending it or sharing it on your social media",
  referralEarnings: "Referral Earnings",
  referralSummary: "Referral Summary",
  yourReferrals: "Your Referrals",
  yourReferralsEarned: "Your Referrals Earned",
  yourReferralsPendingEarned: "Your Referrals Pending Earned",
  joinedDate: "Joined Date",
  date: "Date",
  depositDate: "Deposit Date",
  status: "Status",
  reward: "Reward",
  active: "Active",
  inactive: "Inactive",
  noReferralsFound: "No recent referrals found.",
  totalReferrals: "Total Referrals",
  activeReferrals: "Active Referrals",
  hasDeposited: "Has Deposited",
  yes: "Yes",
  no: "No",
  pending: "Pending",
  paid: "Paid",
  recentEarnings: "Recent Earnings",
  noCommissionsYet: "No commissions yet",
  commission: "commission",
  totalCommission: "Total Commission",
  forgotReferralCode: "Forgot to add referral code in your profile?",
  clickHere: "Click Here",
  referralCodePlaceholder: "Enter your referral code",
  send: "Send",
  sending: "Sending...",
  referralCodeAppliedSuccess: "Referral code applied successfully!",
  invalidOrInactiveReferralCode: "The referral code is invalid or inactive",
};

export default en;
